const messages = {
  'collection.group.high': 'High stool',
  'collection.group.low': 'Counter stool',
  'collection.group.cloverleaf': 'Cloverleaf',
  'collection.group.base': 'Base',
  'collection.about' : 'About {name}',
  'collection.buyNow' : 'Buy now',
  'collection.customize': 'Customize',
  'collection.from' : 'From €{value}',
  'collection.otherArtists' : 'Featured designers',
  'collection.findOutMore' : 'Find out more',
  'contact.agents.title': 'Agents',
  'contact.onlineShops.title': 'Online shops',
  'contact.distributors.address': 'Address',
  'contact.distributors.country': 'Countries',
  'contact.distributors.name': 'Name',
  'contact.distributors.phoneNumber': 'Phone number',
  'contact.distributors.title': 'Distributors',
  'contact.distributors.visitShop': 'Visit the shop',
  'designersPage.artists': 'Artists',
  'flash.dismiss': 'Dismiss',
  'footer.contact.faxNumber': 'Fax number:',
  'footer.contact.phoneNumber': 'Phone number:',
  'footer.cta.button': 'Contact us',
  'footer.cta.title': 'Do you want to know more?',
  'form.collection': 'Collection',
  'form.company': 'Company',
  'form.country': 'Country',
  'form.email': 'Email',
  'form.job': 'Customer type',
  'form.job.architect': 'Architect',
  'form.job.company': 'Company',
  'form.job.journalist': 'Journalist',
  'form.job.other': 'Other',
  'form.job.private': 'Private customer',
  'form.job.retailer': 'Retailer',
  'form.message': 'Message',
  'form.name': 'Your name',
  'form.phoneNumber': 'Phone number',
  'form.sku': 'SKU Product code',
  'form.newsletter': 'Subscribe to our newsletter',
  'form.price': 'Price',
  'form.product': 'Product',
  'form.iHaveRead': 'I have read the ',
  'form.privacy': ' privacy policy',
  'home.collection': 'Collection',
  'home.designBy': 'Design by',
  'home.discoverCollection': 'Discover Collection',
  'news.categories': 'Categories',
  'philosophy.customize': 'Customize Your Chair',
  'requestContactForm.button': 'Request information',
  'requestContactForm.error': 'Your request could not be sent, please correct the errors',
  'requestContactForm.success': 'Your request has been successfully sent',
  'requestInfoForm.button': 'Request information',
  'requestInfoForm.description': 'Send us a note and we’ll get back to you as quickly as possible.',
  'requestInfoForm.error': 'Your request could not be sent, please correct the errors',
  'requestInfoForm.success': 'Your request has been successfully sent',
  'requestInfoForm.title': 'Request information',
  'requestModelForm.button': 'Send me 3D models via email',
  'requestModelForm.description': 'Please fill in the following information and you will receive a link via email to download the 3D model files.',
  'requestModelForm.title': 'Request 3D Model',
  'requestModelForm.error': 'We could\'t send the 3D model, please correct the errors',
  'requestModelForm.success': 'The 3D model has been successfully sent',
  'requestDownloadAccess.button': 'Send me the link via email',
  'requestDownloadAccess.description': 'Please fill in the following information and you will receive a link via email to access the download area.',
  'requestDownloadAccess.title': 'Request link',
  'requestDownloadAccess.error': 'We could\'t send the email, please check for errors',
  'requestDownloadAccess.success': 'The link has been successfully sent',
  'newsletterForm.button': 'Subscribe',
  'newsletterForm.description': 'Subscribe to our newsletter.',
  'newsletterForm.error': 'We could\'t proceed with your request, please check for errors',
  'newsletterForm.success': 'Thank you for subscribing',
  'workTable.manual': 'Instruction manual',
  'workTable.request3dModel': 'Request 3D model',
  'workTable.iWantThis': 'I want this ❤',
  'workTable.requestInformation': 'Request information',
  'workTable.share': 'Share on Facebook',
  'workTable.sheet': 'Data sheet',
  'workTable.accessories': 'Accessories',
  'notFound.title': 'Page not found',
  'notFound.text': 'Sorry, the page you are looking for is not available.. Since you are here take a look at our catalog!',
  'noContent': 'Non ci sono risultati per questa ricerca',
  'iubendaId': '61717891',
};

export default messages;



// WEBPACK FOOTER //
// ./src/locales/en.js